import { LocalizedText } from '@mews/framework';
import { TextKey, ActionType } from '@mews-commander/enums';
import { ColumnAlignment } from '@mews/b2b-ui';
import { compactArray } from '@mews/fp';
import ContextActionMenu from '../../contextMenu/components/ContextActionMenu';

const MessageNotificationContextMenu = ({
    onViewAllMessagesClick,
    onMarkAllSeenClick,
    showMarkAllSeenMenuItem,
}: $TSFixMe) => {
    const viewAllMessagesAction = {
        key: 'viewAllMessagesAction',
        onClick: onViewAllMessagesClick,
        text: <LocalizedText textKey={TextKey.ViewAllMessages} />,
        type: ActionType.Link,
        columnAlignment: ColumnAlignment.Right,
    };

    const markAllAsReadAction = showMarkAllSeenMenuItem
        ? {
              key: 'markAllAsReadAction',
              onClick: onMarkAllSeenClick,
              text: <LocalizedText textKey={TextKey.MarkAllRead} />,
              type: ActionType.Link,
              columnAlignment: ColumnAlignment.Right,
          }
        : null;

    const actions = compactArray([viewAllMessagesAction, markAllAsReadAction]);

    return <ContextActionMenu actions={actions} />;
};

export default MessageNotificationContextMenu;
